export default {
    type: 'numeric',
    format: {
        decimals: 2,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user', 'group', 'buddies'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Edition Worth',
        category: ['Game'],
        description: 'Market value of this specific edition.',
        summarise: {
            prefix: 'Edition worth'
        }
    },
    rules: {
        linked: [],
        legacy: ['version.worth']
    }
}
